

















import { tap } from "rxjs/operators";
import Component from "vue-class-component";
import { Game } from "../../core";
import { DisposeBag } from "../../helpers";
import { LifeRenderProps } from "./LifeRenderProps";

@Component
export default class Controls extends LifeRenderProps {
  public isRunning = false;

  public speedLevel = 50;

  private readonly disposeBag = new DisposeBag();

  public mounted() {
    this.disposeBag.subscribe(
      this.game.isRunning$.pipe(
        tap(isRunning => {
          this.isRunning = isRunning;
        }),
      ),
    );

    this.disposeBag.subscribe(
      this.game.speedLevel$.pipe(
        tap(speedLevel => {
          this.speedLevel = speedLevel;
        }),
      ),
    );
  }

  public beforeDestroy() {
    this.disposeBag.dispose();
  }

  public pause() {
    this.game.pause();
  }

  public play() {
    this.game.play();
  }

  public reset() {
    this.game.resetLife();
  }

  public applyRandomState() {
    this.game.setLife(
      Game.getRandomLife({
        columnsCount: this.columnsCount,
        rowsCount: this.rowsCount,
      }),
    );
  }

  public setSpeedLevel(event: Event) {
    this.game.setSpeed(
      Number.parseInt((event.target as HTMLInputElement).value, 10),
    );
  }
}
